@if (!(isLaunchMode$ | async)) {
  <div class="presenter-widget-placeholder-container" [class.template-mode]="isTemplateMode">
    <ng-content></ng-content>
  </div>
}
